/* eslint-disable no-console */
import { React } from 'react';
import PropTypes from 'prop-types';
import {
  useCartData,
} from '../../hooks/order';
import { useDispatch } from 'react-redux';
import { BroadbandLabel as EarthlinkBroadbandLabel } from '@elnk/earthlink-ui';
import '@elnk/earthlink-ui/styles.css';
import { CLEAR_BROADBAND_DATA } from '../../store/action/Types';

const BroadbandInfo = (props) => {
  const { back } = props;
  const dispatch = useDispatch();
  const { getBroadbandLabel } = useCartData();

  return (
    <div className="broadband-label-container">
      <span className="back-btn" onClick={() => {
        dispatch({ type: CLEAR_BROADBAND_DATA });
        back();
      }}>
        <span className="back-icon">
          <i className="fa-solid fa-arrow-left"></i>
        </span>{' '}
        Back
      </span>

      <EarthlinkBroadbandLabel
        broadbandData={getBroadbandLabel?.data}
        sectionClassList="broadbandlabel"
      />
    </div>
  );
};

BroadbandInfo.propTypes = {
  back: PropTypes.func.isRequired,
};

export default BroadbandInfo;
